import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconEmailOutline } from '@cae/cobalt-react/icons/outline/CobaltIconEmailOutline';
import { CobaltIconPhoneOutline } from '@cae/cobalt-react/icons/outline/CobaltIconPhoneOutline';
import * as React from 'react';

import type { AeContactSectionProps } from './AeContactSection.types';

import styles from './AeContactSection.module.css';

const AeContactSection = React.memo(
  ({
    contact,
    onSubmitRequest,
  }: Readonly<AeContactSectionProps>): React.ReactElement => {
    return (
      <section
        className={styles.section}
        data-testid="ae-contact-section"
        aria-labelledby="ae-contact-section-title"
      >
        <h3 className="heading-01" id="ae-contact-section-title">
          Questions about training?
        </h3>
        <p className={`body-02 ${styles.sectionParagraph}`}>
          For training related topics, contact your Account Executive or{' '}
          <CobaltLink onClick={onSubmitRequest} inline>
            submit a request
          </CobaltLink>
          .
        </p>

        <CobaltTile className={styles.tile} data-testid="ae-contact-card">
          <h3 className={`${styles.contactName} heading-01`}>{contact.name}</h3>
          {(contact.phoneNumber || contact.email) && (
            <div className={styles.contactInfo} data-testid="ae-contact-info">
              {contact.phoneNumber && (
                <span
                  className={styles.contactRow}
                  data-testid="ae-contact-phone"
                >
                  <CobaltIconPhoneOutline size="small" aria-hidden="true" />
                  <a
                    href={`tel:${contact.phoneNumber}`}
                    className={`body-01 ${styles.contactLink}`}
                  >
                    {contact.phoneNumber}
                  </a>
                </span>
              )}
              {contact.email && (
                <span
                  className={styles.contactRow}
                  data-testid="ae-contact-email"
                >
                  <CobaltIconEmailOutline size="small" aria-hidden="true" />
                  <a
                    href={`mailto:${contact.email}`}
                    className={`body-01 ${styles.contactLink}`}
                  >
                    {contact.email}
                  </a>
                </span>
              )}
            </div>
          )}
        </CobaltTile>
      </section>
    );
  }
);

AeContactSection.displayName = 'AeContactSection';

export { AeContactSection };
